$(document).ready(function () {
    if ($('body').data('router-name') !== 'cron-index') {
        return;
    }

    $(function () {

        var updateData = function () {
            var $manualReloadIcon = $('#manualReload i');
            $manualReloadIcon.addClass('fa-spin');

            var $waitSpans = $('[data-wait]');
            var total = $waitSpans.length;
            var completed = 0;

            if (total === 0) {
                $manualReloadIcon.removeClass('fa-spin');
                return;
            }

            $waitSpans.each(function (i, el) {
                var name = $(el).data('wait');
                var $el = $(el);

                $.ajax({
                    url: '/admin/cron/ajax',
                    data: { section: name },
                    success: function (data) {
                        if (data.wait && typeof data.wait[name] !== 'undefined') {
                            $el.html(data.wait[name]);
                        }
                    },
                    complete: function () {
                        completed++;
                        if (completed >= total) {
                            $manualReloadIcon.removeClass('fa-spin');
                        }
                    }
                });
            });
        };

        var countdown = 20;
        var $countdownDisplay = $('#reloadCountdown');

        function updateCountdown() {
            $countdownDisplay.text('Reload in ' + countdown + 's');
            if (countdown <= 0) {
                updateData();
                countdown = 20;
            } else {
                countdown--;
            }
        }

        updateData();
        updateCountdown();

        setInterval(updateCountdown, 1000);

        $('#manualReload').on('click', function (e) {
            e.preventDefault();
            updateData();
            countdown = 20;
            updateCountdown();
        });

        $('[data-cron-content]').delegate('[data-cron-link]', 'click', function (ev) {
            ev.preventDefault();
            var $a = $(this);
            var $li = $a.closest('li');
            var url = $a.attr('href');
            var $status = $a.closest('td').find('[data-cron-status]');
            var $messages = $('.messages');

            var addStatus = function (icon) {
                $status.html(icon);
                setTimeout(function () {
                    $status.find('i').fadeOut();
                }, 1000);
            };

            $status.html('<i class="fas fa-spinner"></i>');
            $.ajax({
                url: url,
                success: function (data) {
                    if (typeof data.status !== 'undefined' && data.status === 'success') {
                        addStatus('<i class="fas fa-check fa-24 text-success"></i>');
                    }
                    else {
                        addStatus('<i class="fas fa-times fa-24 text-danger"></i>');
                        if (typeof data.message !== 'undefined') {
                            $messages.empty().append($('<div/>').addClass('alert alert-danger').text(data.message));
                        }
                    }
                    updateData();
                },
                error: function () {
                    addStatus('<i class="fas fa-times fa-24 text-danger"></i>');
                    $messages.empty().append($('<div/>').addClass('alert alert-danger').text('Response error'));
                }
            });
        })
    });
});
